export default __webpack_public_path__ + "static/media/services02.ea532ec0.png";